import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useFindSimulationBestOffer({ proposalId = '', token = '' }) {
  const mutation = useMutation({
    mutationKey: ['find-simulation-best-offer', proposalId, token],
    mutationFn: async () => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/simulation/best-offer`), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
